export async function loadCatalogSearchParts({ loadRows, loadLines, isCurrent = () => true, retryDelay = () => new Promise(resolve => setTimeout(resolve, 450)) }) {
  const rowsWithRetry = async () => {
    try { return await loadRows() }
    catch (firstError) {
      if (!isCurrent()) throw firstError
      await retryDelay()
      if (!isCurrent()) throw firstError
      return loadRows()
    }
  }
  const [rows, lines] = await Promise.allSettled([rowsWithRetry(), Promise.resolve().then(loadLines)])
  return {
    rows: rows.status === 'fulfilled' ? rows.value || [] : [],
    lines: lines.status === 'fulfilled' ? lines.value || [] : [],
    rowError: rows.status === 'rejected' ? rows.reason : null,
    lineError: lines.status === 'rejected' ? lines.reason : null,
  }
}

export function catalogAvailabilityMessage({ rows, lines, rowError, lineError }) {
  if (rowError && lines.length) return 'Some search results are temporarily unavailable. Please try again if your bottle is not shown.'
  if (lineError && rows.length) return 'Some search results are temporarily unavailable. Please try again if your bottle is not shown.'
  if (rowError || lineError) return 'Search is temporarily unavailable. Please try again; this does not mean the fragrance is missing.'
  return null
}
